import { useTenant } from 'queries/hooks/useTenant';
import Auth from 'services/Auth';
import { shouldShowOnboarding } from './shouldShowOnboarding';

type ShouldShowOnboardingState = {
    isLoading: boolean;
    shouldShowOnboarding: boolean;
};

/**
 * Whether the signed-in user should be shown the first-run onboarding flow for the current tenant.
 * `shouldShowOnboarding` is false while the tenant is loading.
 */
export const useShouldShowOnboarding = (): ShouldShowOnboardingState => {
    const { data: tenant, isLoading } = useTenant();

    const isSquaredUpAdministrator = Auth.user?.tenants?.includes('SquaredUp Cloud Administrators') === true;

    return { isLoading, shouldShowOnboarding: shouldShowOnboarding(tenant, isSquaredUpAdministrator) };
};
